<app-keycom-container
  *ngIf="user"
  [logo]="'assets/images/ovt-logo.svg'"
  [title]="title"
  [user]="user"
  (helpAction)="helpAction($event)"
  (profileAction)="profileAction($event)"
>
  <router-outlet></router-outlet>
</app-keycom-container>
